var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarJ = function SvgDefaultAvatarJ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_j_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_j_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 55.8c4.8 0 8.7-2.3 8.7-8.9V32.5c0-2.4.1-4.4.6-4.6 2.1-.1 3-.4 3-1.3 0-1.2-2.2-1.6-6.3-1.6s-6.3.4-6.3 1.6c0 .9 1 1.2 3.3 1.3.5.2.7 2.1.7 4.6v14.3c0 4.4-1.6 6.2-4.1 6.2-2.2 0-3-1.4-3-2 0-.3.3-.5.5-.7.5-.5.9-1.1.9-2 0-1.6-1.2-2.9-3-2.9-2.1 0-3.4 1.5-3.4 3.8-.1 3.7 3 6.6 8.4 6.6z"
  })));
};
export default SvgDefaultAvatarJ;